// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-AccountSetting-Checkout-CheckoutForm-__CheckoutForm___3yZdn","form-group":"app-pages-AccountSetting-Checkout-CheckoutForm-__CheckoutForm___2Pm1D","switchbox":"app-pages-AccountSetting-Checkout-CheckoutForm-__CheckoutForm___jU1SQ"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/Checkout/CheckoutForm/CheckoutForm.css
// module id = 2045
// module chunks = 0